var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", grow: "", shrink: "" } },
    [
      _c("w-row", { attrs: { center: "" } }, [_vm._t("default")], 2),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                { staticClass: "shrink", style: { maxHeight: "100%" } },
                [
                  _c(
                    "w-scroll-view",
                    [
                      _c("app-dossier-edit-form", {
                        attrs: { value: _vm.value },
                      }),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12", md: "6", xl: "4" } },
                                [
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          return _vm.fixPartitions()
                                        },
                                      },
                                    },
                                    [_vm._v("Partities fixen")]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          return _vm.runMigrations()
                                        },
                                      },
                                    },
                                    [_vm._v("Databse migreren")]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          _vm.runSpecificMigrationModal = true
                                        },
                                      },
                                    },
                                    [_vm._v("Specifieke migratie uitvoeren")]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          _vm.recreateStockOutsModal = true
                                        },
                                      },
                                    },
                                    [_vm._v("Stock outs opnieuw aanmaken")]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          return _vm.createMissingProducts()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Ontbrekende producten uit de verkoopdetail opnieuw aanmaken"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          return _vm.createMissingExtraFields()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Ontbrekende extra velden aanmaken"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          return _vm.recomputeProductBuyPrices()
                                        },
                                      },
                                    },
                                    [_vm._v("Aankoopprijzen herberekenen")]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          return _vm.createPriceListItemsOfAllProducts()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Prijslijsten maken van alle artikelen"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteUnusedProducts()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Ongebruikte artikelen verwijderen"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          return _vm.createPriceListItemsOfAllProductsAndDeleteUnused()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " Prijslijsten maken van alle artikelen en ongebruikte artikelen verwijderen "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          return _vm.fixSaleActions()
                                        },
                                      },
                                    },
                                    [_vm._v("Verkoop acties fixen")]
                                  ),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "mb",
                                      on: {
                                        click: function ($event) {
                                          _vm.createQuickCopyModalOpen = true
                                        },
                                      },
                                    },
                                    [_vm._v("Dossier kopieren")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(" Save ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-modal",
                    {
                      model: {
                        value: _vm.recreateStockOutsModal,
                        callback: function ($$v) {
                          _vm.recreateStockOutsModal = $$v
                        },
                        expression: "recreateStockOutsModal",
                      },
                    },
                    [
                      _vm.recreateStockOutsModal
                        ? _c("app-recreate-stock-outs-modal", {
                            attrs: { "dossier-id": _vm.value.id },
                            on: {
                              close: function ($event) {
                                _vm.recreateStockOutsModal = false
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.fixSaleActionsModal
                    ? _c(
                        "w-modal",
                        { attrs: { value: "" } },
                        [
                          _c("app-fix-sale-actions-modal", {
                            attrs: { "dossier-id": _vm.value.id },
                            on: {
                              close: function ($event) {
                                _vm.fixSaleActionsModal = false
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-modal",
                    {
                      model: {
                        value: _vm.runSpecificMigrationModal,
                        callback: function ($$v) {
                          _vm.runSpecificMigrationModal = $$v
                        },
                        expression: "runSpecificMigrationModal",
                      },
                    },
                    [
                      _vm.runSpecificMigrationModal
                        ? _c("app-run-specific-migration-modal", {
                            attrs: { "dossier-id": _vm.value.id },
                            on: {
                              close: function ($event) {
                                _vm.runSpecificMigrationModal = false
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.createQuickCopyModalOpen
                    ? _c("app-create-quick-copy-modal", {
                        attrs: {
                          "original-company": _vm.company,
                          "original-dossier": _vm.value,
                        },
                        on: {
                          close: function ($event) {
                            _vm.createQuickCopyModalOpen = false
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }